
import { useContext } from 'react';
import { mixpanelContext, MixpanelContext } from '@app/site/mixpanel/MixpanelProvider';

export const useMixpanel = (): MixpanelContext => useContext(mixpanelContext);